<template>
  <div class="product-rate-datas">
    <el-dialog
      :model-value="visible"
      :before-close="() => {
        emit('close');
      }"
      width="800"
      align-center
    >
      <template #header>
        <div class="my-header">
          <h4 class="px-2 pb-3 text-xl text-[#344767] font-semibold">
            开通产品
          </h4>
        </div>
      </template>
      <el-skeleton v-if="loading" :rows="5" animated />
      <el-table
        v-else
        class="merge-table"
        :data="data"
        :span-method="objectSpanMethod"
        :border="true"
        :max-height="466"
        :scrollbar-always-on="true"
        style="width: 100%;"
      >
        <el-table-column align="center" :min-width="120" prop="usageName" label="使用场景" />
        <el-table-column align="center" :min-width="120" prop="productName" label="产品名称" />

        <el-table-column v-if="isAgent" align="center" :min-width="100" prop="cost" label="产品费率">
          <template #default="scope">
            {{ scope.row.agentCost ? `${scope.row.agentCost}${costUnitTypeText[scope.row.costUnitType]}` : '--' }}
          </template>
        </el-table-column>

        <el-table-column v-else align="center" :min-width="100" prop="cost" label="产品费率">
          <template #default="scope">
            {{ scope.row.cost ? `${scope.row.cost}${costUnitTypeText[scope.row.costUnitType]}` : '--' }}
          </template>
        </el-table-column>

        <el-table-column align="center" :min-width="100" prop="productDescription" label="产品说明">
          <template #default="scope">
            {{ scope.row.productDescription }}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script setup lang="ts">
import { mergeTableColumns } from '@core/tools';
import { computed, PropType } from 'vue';
import { ref, watch } from 'vue';
import { IProductFee } from '@core/main/types';

const loading = ref(false);
const spanArr = ref([]);
const position = ref(0);
const emit = defineEmits<{close: []}>();

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  data: {
    type: Object as PropType<IProductFee[]>,
    default: () => {},
  },
  term: {
    type: String as PropType<'agent' | 'company'>,
    default: 'agent',
  },
});

const costUnitTypeText = {
  1: '%',
  2: '元/笔',
  3: '元/户',
};

const isAgent = computed(() => props.term === 'agent');

function onMergeLines(list: IProductFee[]) {
  spanArr.value = [];
  position.value = 0;
  if (list && list.length > 0) {
    const { colArr, position: index } = mergeTableColumns(list, 'usageCode');

    spanArr.value = colArr;
    position.value = index;
  }
}

function objectSpanMethod({ row, column, rowIndex, columnIndex }) {
  if (columnIndex === 0) {
    const _row = spanArr.value[rowIndex];
    const _col = _row > 0 ? 1 : 0;

    return {
      rowspan: _row,
      colspan: _col,
    };
  }
}

watch(
  [
    () => props.visible,
    () => props.data,
  ],
  () => {
    if (props.visible && props.data) {
      onMergeLines(props.data);
    }
  },
  { immediate: true },
);

</script>

<style lang="scss" scoped>
.product-rate-datas {
  :deep(.el-dialog__body) {
    padding-bottom: 16px;
  }
}
</style>
